import React, { useState } from "react";
import { NavLink } from "react-router-dom";

import { Subscribe } from "../HomePage";

const Footer = () => {

  return (
    <>
    <Subscribe />
      <footer className="page_footer ds s-pt-60 s-pb-15 s-pb-lg-30 s-pt-lg-90 s-pb-xl-40 s-pt-xl-120 c-mb-20 c-gutter-30">
        <div className="container">
          <div className="row">
            <div
              className="col-md-6 col-xl-4 text-center text-md-left animate"
              data-animation="fadeInUp"
            >
              <div className="widget widget_text">
                <h3 className="widget-title special-heading underline">JMTY</h3>

                <p>
                  JustMovedToYankee is an education and lifestyle consulting
                  company committed to helping Africans actualize their dreams
                  of studying, working and ultimately living in the US, legally.
                  We do this through our online community, offline events and
                  1:1 consultation.
                </p>
              </div>
            </div>
            <div
              className="col-md-6 col-xl-4 text-center text-md-left animate"
              data-animation="fadeInUp"
            ></div>

            <div
              className="col-md-6 col-xl-4 text-center text-md-left animate"
              data-animation="fadeInUp"
            >
              <div className="widget widget_nav_menu">
                <h3 className="widget-title special-heading underline">
                  Links
                </h3>
                <div className="row c-gutter-30">
                  <div className="col-md-6 mb-0">
                    <ul className="menu mb-0 list-bordered">
                      <li className="border-top-0">
                        <NavLink to="/our-story">
                          <a href="#">Our Story</a>
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/services">Services</NavLink>
                      </li>
                    </ul>
                  </div>
                  <div className="col-md-6">
                    <ul className="menu mb-0 list-bordered">
                      <li className="border-top-0">
                        <a
                          href="https://docs.google.com/forms/d/e/1FAIpQLSdSxtJYcmf-c0ABnq7iXycpqx8KgaEiznxPr93axFI_u_VHqQ/viewform?vc=0&c=0&w=1&flr=0&gxids=7757"
                          target="_blank"
                        >
                          Consultation
                        </a>
                      </li>
                      {/* <li>
                      <a href="#">JMTY Blueprint</a>
                    </li> */}
                      <li>
                        <NavLink to="/contact">
                          <a href="#">Contact Us</a>
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>

      <section className="page_copyright ds ms s-pt-30 s-pb-20 c-mb-10 c-mb-lg-0 s-py-lg-20">
        <div className="container">
          <div className="row align-items-center">
            <div className="divider-25 d-none d-lg-block"></div>
            <div className="col-lg-6">
              <div className="social-icons social-icons-tilled text-center text-lg-left w-100">
                <a
                  href="https://www.instagram.com/justmovedtoyankee/?igshid=18t23l69fp0ah"
                  target="_blank"
                  className="fab fa-instagram "
                  title="instagram"
                >
                  <span>instagram</span>
                </a>
                <a
                  href="https://www.linkedin.com/company/just-moved-to-yankee-jmty"
                  target="_blank"
                  className="fab fa-linkedin"
                  title="linkedin"
                >
                  <span>linkedin</span>
                </a>
              </div>
            </div>
            <div className="col-lg-6 text-center text-lg-right">
              <p>
                &copy; JustMovedToYankee{" "}
                <span className="copyright_year">2021</span>. All Rights
                Reserved
              </p>
            </div>
            <div className="divider-25 d-none d-lg-block"></div>
          </div>
        </div>
      </section>
    </>
  );
};
export default Footer;
